import { useCheckout } from '@/contexts/checkoutContext';
import { useDataLayer } from '@/hooks/useDataLayer';
import { useEffect, useRef } from 'react';

export const useViewCart = () => {
  const {
    checkoutData: { items },
  } = useCheckout();
  const { viewCart } = useDataLayer();
  const firedRef = useRef(false);

  useEffect(() => {
    if (firedRef.current || !items?.length) {
      return;
    }
    firedRef.current = true;
    viewCart(items);
  }, [items, viewCart]);
};
